import {Component, Injector, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ControllerComponent} from '../../../../Controller/controller-component';
import {OrderStatusTrackDto} from '../../../../../Models/Purchases/Orders/order-status.interface';
import {OrderStatusEnum} from '../../../../../Shared/Enum/order-status.enum';

@Component({
  selector: 'app-order-status-track',
  templateUrl: './order-status-track.component.html',
  styleUrls: ['./order-status-track.component.scss'],
  standalone: false
})
export class OrderStatusTrackComponent extends ControllerComponent implements OnChanges, OnInit {

  @Input() orderStatus: number = 0;

  currentStatus?: OrderStatusTrackDto;
  statusList: OrderStatusTrackDto[] = [];

  get trackLineProgressWidth(): number {
    return this.currentStatus ? (this.currentStatus.step - 1) * 100 / (this.statusList.length - 1) : 0;
  }

  constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.initStatusList();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['orderStatus']) {
      this.getCurrentStatus();
    }
  }


  /**
   * Inicializar lista de estados
   *
   */
  initStatusList() {
    this.statusList = [
      {
        step: 1,
        ids: [OrderStatusEnum.pendent],
        nombre: this.translate.instant('CONST.ORDER_STATUS.PENDING'),
        description: this.translate.instant('CONST.ORDER_STATUS.PENDING_DESC')
      },
      {
        step: 2,
        ids: [OrderStatusEnum.finished],
        nombre: this.translate.instant('CONST.ORDER_STATUS.FINISHED'),
        description: this.translate.instant('CONST.ORDER_STATUS.FINISHED_DESC')
      },
      {
        step: 3,
        ids: [OrderStatusEnum.sent, OrderStatusEnum.inProcess, OrderStatusEnum.partiallyDelivered],
        nombre: this.translate.instant('CONST.ORDER_STATUS.SENT'),
        description: this.translate.instant('CONST.ORDER_STATUS.SENT_DESC')
      },
      {
        step: 4,
        ids: [OrderStatusEnum.received],
        nombre: this.translate.instant('CONST.ORDER_STATUS.RECEIVED'),
        description: this.translate.instant('CONST.ORDER_STATUS.RECEIVED_DESC')
      },
    ];
  }


  /**
   * Obtener el estado actual del pedido
   *
   */
  getCurrentStatus() {
    const currentStatus = this.statusList.find((state) => state.ids.includes(this.orderStatus));

    if (!currentStatus) {
      return;
    }

    this.currentStatus = currentStatus;
    this.statusList = this.statusList.map((state) => ({
      ...state,
      done: state.step <= currentStatus.step,
      current: state.step === currentStatus.step,
    }));
  }


  /**
   * Mostrar la descripción del estado
   *
   */
  async showStateDescription(state: OrderStatusTrackDto) {
    const alert = await this.alertCtrl.create({
      enterAnimation: this.animationCtrl.showAlertAnimation,
      leaveAnimation: this.animationCtrl.hideAlertAnimation,
      header: this.translate.instant('PURCHASES.ORDERS.ORDER') + ' ' + state.nombre.toLowerCase(),
      message: state.description,
      buttons: [
        {
          text: this.translate.instant('COMMON.ACCEPT'),
          role: 'destructive'
        },
      ]
    });

    await alert.present();
  }

}
